import { StateVerifier } from '../oidc/state-verifier';
import { V2Router } from '../router/v2.router';
import { PkceManager } from '../oidc/pkce-manager';
import { ITokenManager } from '../token-manager/token-manager.types';
import { ClientConfig } from '../types';
import { transformTokenResponse } from '../token-manager/token-manager.utils';

type ExchangeCodeForTokensOptions = {
  clientConfig: ClientConfig;
  code: string;
  stateVerifier: StateVerifier;
  router: V2Router;
  pkce: PkceManager;
  tokenManager: ITokenManager;
};
export async function exchangeCodeForTokens({
  clientConfig,
  code,
  stateVerifier,
  router,
  pkce,
  tokenManager,
}: ExchangeCodeForTokensOptions) {
  const tokenResponse = await router.token({
    client_id: clientConfig.clientId,
    redirect_uri: clientConfig.redirectUri,
    code_verifier: pkce.retrieveCodeVerifier(),
    grant_type: 'authorization_code',
    code,
  });
  const tokens = transformTokenResponse(tokenResponse, clientConfig.issuer);
  // Before we persist tokens, verify the id token nonce
  await stateVerifier.verifyNonce(tokens.idToken?.claims.nonce);
  tokenManager.setTokens(tokens);
  pkce.removeCodeVerifier();

  return tokens;
}
